import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "services/api.service";
import { PickupContact } from "types/pickupContact";

export default function useContacts() {
  const params = useParams();
  const [contacts, setContacts] = useState<PickupContact[]>();

  const getContacts = useCallback(() => {
    return api.get("/contacts").then(({ data }) => {
      setContacts(data.contacts);
    });
  }, []);

  useEffect(() => {
    getContacts();
  }, [params.uuid, getContacts]);

  const createContact = (contact: PickupContact) => {
    return api.post<PickupContact>("/contacts", { contact }).then((response) => getContacts().then(() => response));
  };

  const updateContact = (uuid: string, contact: PickupContact) => {
    return api.put(`/contacts/${uuid}`, { contact }).then(() => getContacts());
  };

  return {
    contacts,
    createContact,
    updateContact,
    refreshContacts: getContacts,
  };
}
